import { PlaceholderInput, PlaceholderFlattenInput } from "./PlaceholderInput";
import UIFetchService from "../Service/UIFetchService";
import auth from "../Service/AuthFetchService";
import { ODPSParser } from "../Service/ODPSParser";
import {
  isEmpty,
  isNotEmpty,
  isTimeFormat,
  parseUrlSearch,
} from "../Service/Utils";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { HotTable } from "@handsontable/react";
import copy from "copy-to-clipboard";
import SyntaxHighlighter from "react-syntax-highlighter";
import { xcode } from "react-syntax-highlighter/dist/esm/styles/hljs";
import * as monaco from "monaco-editor/esm/vs/editor/editor.api.js";
import "./hidescroll.css";
import {
  Row,
  Col,
  Button,
  message,
  Tabs,
  Layout,
  Divider,
  Space,
  Progress,
  Result,
  Modal,
  Tooltip,
  Input,
  Checkbox,
  Radio,
  List,
  Menu,
  Dropdown,
} from "antd";
import {
  LeftOutlined,
  PlusOutlined,
  DeleteOutlined,
  LoadingOutlined,
  PlayCircleOutlined,
  PauseCircleOutlined,
  CaretDownOutlined,
  SaveOutlined,
  BugOutlined,
  SyncOutlined,
  HomeOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";

const odpsFuns = [];
for (let f of new Set(ODPSParser.odpsFunctions).values()) {
  odpsFuns.push(f);
}

class TemplateQueryingViewV2 extends React.Component {
  static siderDelta = 130;
  static tableDelta = 178;

  constructor() {
    super();
    this.state = {
      tab: "dimensions",
      template: {},
      projection: [],
      original: [],
      md: {},
      whereClause: {},
      siderHeight:
        document.body.clientHeight - TemplateQueryingViewV2.siderDelta,
    };
    this.whereClauseRef = React.createRef();

    const params = parseUrlSearch(window.location.search);
    this.editing = params.editing !== undefined;
  }

  render() {
    return (
      <>
        <Row justify="space-between" style={{ marginBottom: "20px" }}>
          <Col>
            <Button
              icon={<LeftOutlined />}
              href={
                this.editing
                  ? `/querying_guide/template/${this.state.template.id}/detail`
                  : "/querying_guide/dashboard"
              }
              type="link"
            >
              返回
            </Button>
            {this.editing && (
              <Button
                icon={<HomeOutlined />}
                href="/querying_guide/dashboard"
                type="link"
              />
            )}
          </Col>
          <Col>
            <span style={{ fontSize: 20, fontWeight: 600 }}>
              {this.state.template.name}
            </span>
            {/* <Tooltip title='复制取数链接'>
                        <Button
                            size='small'
                            icon={<LinkOutlined />}
                            type='link'
                            onClick={() => {
                                if (copy(`${window.location.origin}/standalone/templates/${this.state.template.id}`)) {
                                    message.success('复制成功');
                                } else {
                                    message.success('复制失败');
                                }
                            }}
                        />
                    </Tooltip> */}
          </Col>
          <Col>
            <span style={{ fontSize: 12, color: "gray" }}>
              创建人:{this.state.template.creatorName}
            </span>
          </Col>
        </Row>
        <Layout>
          <Layout.Sider
            theme="light"
            width={400}
            style={{
              height: this.state.siderHeight,
              borderRadius: "4px",
              border: "1px solid rgb(221, 234, 255)",
              overflowY: "auto",
              padding: "4px",
            }}
          >
            <QueryingSiderView
              template={this.state.template}
              hint={this.state.hint}
              tab={this.state.tab}
              willAddField={(which) => {
                switch (which) {
                  case "DIMENSION":
                    this.setState({ dimensionEditorVisible: true });
                    break;
                  case "INDICATOR":
                    this.setState({ indicatorEditorVisible: true });
                    break;
                  default:
                    break;
                }
                this.setState({ incomingAddOrUpdate: true });
              }}
              willEditField={(name) => {
                const incomingIndex = this.state.template.projection.findIndex(
                  (p) => p.name === name
                );
                const incomingData = {
                  ...this.state.template.projection[incomingIndex],
                };
                if (incomingData.kind === "DIMENSION") {
                  this.setState({ dimensionEditorVisible: true });
                } else {
                  this.setState({ indicatorEditorVisible: true });
                }
                this.setState({
                  incomingAddOrUpdate: false,
                  incomingIndex,
                  incomingData,
                });
              }}
              onDeleteField={async (name) => {
                const incomingIndex = this.state.template.projection.findIndex(
                  (p) => p.name === name
                );
                const data = this.state.template.projection[incomingIndex];
                await UIFetchService.delete(
                  `/api/v1/querying_guide/templates/${this.state.template.id}/projections/${data.id}`
                );
                this.setState(({ template }) => {
                  template.projection.splice(incomingIndex, 1);
                  return { template };
                });
              }}
              onTabChange={(tab) => this.setState({ tab })}
              projection={this.state.projection}
              original={this.state.original}
              onProjectionChange={(projection) => this.setState({ projection })}
              onOriginalChange={(original) => this.setState({ original })}
              running={this.state.running}
              onQuery={() => {
                this.postQueryingJob(this.state.template.id, this.state.tab);
                this.saveProfile();
              }}
              onCancel={() => this.cancelQueryingJob()}
            />
          </Layout.Sider>
          <Layout.Content style={{ paddingLeft: "30px" }}>
            <Row ref={this.whereClauseRef} style={{ margin: "0 4px 0 0" }}>
              <Col
                flex="100%"
                style={{
                  //height: this.state.siderHeight,
                  borderRadius: "4px",
                  border: "1px solid rgb(221, 234, 255)",
                  overflowY: "auto",
                  padding: "4px",
                  position: "relative",
                }}
              >
                <QueryingWherePanel
                  template={this.state.template}
                  md={this.state.md}
                  running={this.state.running}
                  value={this.state.whereClause}
                  onChange={(whereClause) => this.setState({ whereClause })}
                />
                {this.state.running ? (
                  <Button
                    style={{ position: "absolute", bottom: 4, right: 10 }}
                    icon={<PauseCircleOutlined />}
                    //type='link'
                    hidden={this.isPlaceholdersEmpty()}
                    danger
                    size="small"
                    onClick={() => {
                      this.cancelQueryingJob();
                    }}
                  >
                    终止
                  </Button>
                ) : (
                  <Button
                    style={{ position: "absolute", bottom: 4, right: 10 }}
                    icon={<PlayCircleOutlined />}
                    hidden={this.isPlaceholdersEmpty()}
                    disabled={!this.canRunning()}
                    type="primary"
                    size="small"
                    onClick={() => {
                      this.postQueryingJob(
                        this.state.template.id,
                        this.state.tab
                      );
                      this.saveProfile();
                    }}
                  >
                    查询
                  </Button>
                )}
              </Col>
            </Row>
            <Row style={{ margin: "12px 4px 0 0" }}>
              <QueryingResultsView
                tab={this.state.tab}
                template={this.state.template}
                namedProjection={this.state.namedProjection}
                projection={this.state.projection}
                original={this.state.original}
                whereClause={this.state.whereClause}
                tableHeight={this.state.tableHeight}
                running={this.state.running}
                onJobStart={() => this.setState({ running: true })}
                onJobEnd={() => this.setState({ running: false })}
                returningCallback={([postJob, cancelJob]) => {
                  this.postQueryingJob = postJob;
                  this.cancelQueryingJob = cancelJob;
                }}
              />
            </Row>
          </Layout.Content>
        </Layout>
        {this.state.indicatorEditorVisible && (
          <IndicatorEditorModal
            visible={this.state.indicatorEditorVisible}
            onCancel={() => this.setState({ indicatorEditorVisible: false })}
            onOk={async (indicator, index, addOrUpdate) => {
              indicator.kind = "INDICATOR";

              if (addOrUpdate) {
                await this.addProjection(indicator);
              } else {
                await this.updateProjection(indicator, index);
              }

              this.setState({ indicatorEditorVisible: false });
            }}
            addOrUpdate={this.state.incomingAddOrUpdate}
            incomingIndicator={this.state.incomingData}
            incomingIndex={this.state.incomingIndex}
            fields={this.state.template.projection.filter(
              (p) => p.kind === "ORIGINAL"
            )}
            alreadyExistName={this.alreadyExistName.bind(this)}
          />
        )}
        {this.state.dimensionEditorVisible && (
          <DimensionEditorModal
            visible={this.state.dimensionEditorVisible}
            onCancel={() => this.setState({ dimensionEditorVisible: false })}
            onOk={async (dimension, index, addOrUpdate) => {
              dimension.kind = "DIMENSION";
              if (addOrUpdate) {
                await this.addProjection(dimension);
              } else {
                await this.updateProjection(dimension, index);
              }
              this.setState({ dimensionEditorVisible: false });
            }}
            addOrUpdate={this.state.incomingAddOrUpdate}
            incomingDimension={this.state.incomingData}
            incomingIndex={this.state.incomingIndex}
            fields={this.state.template.projection.filter(
              (col) => col.kind === "ORIGINAL"
            )}
            alreadyExistName={this.alreadyExistName.bind(this)}
          />
        )}
      </>
    );
  }

  async componentDidMount() {
    const offset =
      typeof this.props.offset === "number" ? this.props.offset : 0;
    window.onresize = () => {
      this.setState({
        siderHeight:
          document.body.clientHeight -
          TemplateQueryingViewV2.siderDelta +
          offset,
      });
      let h = this.whereClauseRef?.current?.clientHeight;
      if (!(h >= 0)) {
        h = 0;
      }
      //console.log(this.whereClauseRef?.current, h);
      let tableHeight =
        document.body.clientHeight -
        TemplateQueryingViewV2.tableDelta -
        h +
        offset;
      if (tableHeight < 300) {
        tableHeight = 300;
      }
      this.setState({ tableHeight });
    };

    const template = await UIFetchService.get(
      `/api/v1/querying_guide/templates/${this.props.tmplId}`
    );
    this.setState({ template });
    this.setState(({ md }) => {
      md.staffs = template.staffs;
      return { md };
    });

    if (this.editing) {
      const userProjs = template.projection.filter(
        (p) => p.kind === "DIMENSION" || p.kind === "INDICATOR"
      );
      if (userProjs.length === 0) {
        Modal.warning({
          title: "提示",
          content: (
            <>
              <Row>
                <Col>
                  <span>还没有创建维度和指标。</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <span>可以点击维度/指标旁边的</span>
                  <Button size="small" type="link" icon={<PlusOutlined />} />
                  <span>来自定义新的维度和指标。</span>
                </Col>
              </Row>
            </>
          ),
          onOk: () => {
            this.setState({ hint: true });
            setTimeout(() => this.setState({ hint: false }), 3000);
          },
        });
      }
    }

    if (isNotEmpty(template.placeholders)) {
      const placeholders = {};
      for (let ph of template.placeholders) {
        placeholders[ph.name] = ph;
      }
      this.setState({ placeholderKeys: Object.keys(placeholders).sort() });

      const namedProjection = {};
      for (let col of template.projection) {
        namedProjection[col.name.toLowerCase()] = col.desc.toLowerCase();
      }
      this.setState({ namedProjection });
    }
    if (!this.props.invalidate) {
      const lsJson = localStorage.getItem(
        `queryGuide.${this.props.tmplId}.params`
      );
      if (isNotEmpty(lsJson)) {
        const namedProjection = {};
        for (let col of template.projection) {
          namedProjection[col.name] = col;
        }
        const json = JSON.parse(lsJson);
        this.setState({
          projection: json.projection,
          whereClause: json.placeholders,
        });
      }
    }

    UIFetchService.get("/api/v1/metadata/provinces/tree").then((provinces) =>
      this.setState(({ md }) => {
        md.provinces = provinces;
        return { md };
      })
    );
    UIFetchService.get("/api/v1/metadata/word_books/tree").then(
      (bookCategories) =>
        this.setState(({ md }) => {
          md.bookCategories = bookCategories;
          return { md };
        })
    );
    UIFetchService.get("/api/v1/metadata/ad/to_groups_to_objects").then(
      (toGroupsToObjects) =>
        this.setState(({ md }) => {
          md.toGroupsToObjects = toGroupsToObjects;
          return { md };
        })
    );
    UIFetchService.get("/api/v1/metadata/ad/ad_resource_slots").then(
      (adSlots) =>
        this.setState(({ md }) => {
          md.adSlots = adSlots;
          return { md };
        })
    );
    window.onresize();

    auth.appendLog(`天机指标查询-查看模版:${this.state.template.name}`);
  }

  async addProjection(proj) {
    const rs = await UIFetchService.post(
      `/api/v1/querying_guide/templates/${this.state.template.id}/projections`,
      proj
    );
    if (!rs) {
      return;
    }
    proj.id = rs.id;
    this.setState(({ template, namedProjection }) => {
      template.projection = [...template.projection, proj];
      namedProjection[proj.name.toLowerCase()] = proj.desc.toLowerCase();
      return { template, namedProjection };
    });
    // namedProjection[col.name] = col.desc;
  }

  async updateProjection(proj, index) {
    const rs = await UIFetchService.put(
      `/api/v1/querying_guide/templates/${this.state.template.id}/projections`,
      proj
    );
    if (!rs) {
      return;
    }
    this.setState(({ template, namedProjection }) => {
      template.projection = [...template.projection];
      template.projection[index] = proj;
      namedProjection[proj.name.toLowerCase()] = proj.desc.toLowerCase();
      return { template, namedProjection };
    });
  }

  canRunning() {
    if (this.state.tab === "dimensions") {
      return this.state.projection.length > 0;
    } else {
      return this.state.original.length > 0;
    }
  }

  alreadyExistName(name) {
    return (
      this.state.template.projection.find((p) => p.name === name) !== undefined
    );
  }

  isPlaceholdersEmpty() {
    if (this.state.template.placeholders === undefined) {
      return true;
    }
    return Object.keys(this.state.template.placeholders).length === 0;
  }

  saveProfile() {
    const json = {
      projection: this.state.projection,
      placeholders: this.state.whereClause,
    };
    localStorage.setItem(
      `queryGuide.${this.props.tmplId}.params`,
      JSON.stringify(json)
    );
  }
}

function QueryingWherePanel(props) {
  const placeholders = props.template.placeholders
    ? props.template.placeholders
    : [];
  const whereClause = props.value;
  const setWhereClause = props.onChange;

  const dateTimeParams = () => {
    const holders = placeholders.filter((p) => isTimeFormat(p.format));
    const keys = {};
    holders.forEach((h) => {
      keys[h.name] = 0;
    });
    return holders
      .filter((h) => {
        if (keys[h.name] > 0) {
          return false;
        }
        keys[h.name]++;
        return true;
      })
      .map((holder) => {
        const required = props.template.requires[holder.name];
        if (required === undefined) {
          holder.required = true;
        } else {
          holder.required = required;
        }
        return holder;
      });
  };

  const normalParams = () => {
    const holders = placeholders.filter((p) => !isTimeFormat(p.format));
    const keys = {};
    holders.forEach((h) => {
      keys[h.name] = 0;
    });
    return holders.filter((h) => {
      if (keys[h.name] > 0) {
        return false;
      }
      keys[h.name]++;
      return true;
    });
  };

  return (
    <>
      <Row>
        {dateTimeParams().map((param, index) => (
          <>
            <Col
              key={`title.${param.name}`}
              flex={"80px"}
              style={{ alignSelf: "center", textAlign: "right" }}
            >
              {param.required && (
                <span style={{ fontSize: 12, color: "red" }}>*</span>
              )}
              <span style={{ fontSize: 12, color: "gray" }}>
                {param.name} :{" "}
              </span>
            </Col>
            <Col
              key={`input.${param.name}`}
              flex={`${param.format === "DATE_RANGE" ? 240 : 140}px`}
              style={{ padding: "3px" }}
            >
              <PlaceholderInput
                md={props.md}
                disabled={props.running}
                placeholder={param}
                value={whereClause[param.name]}
                onChange={(value) => {
                  whereClause[param.name] = value;
                  setWhereClause(whereClause);
                }}
              />
            </Col>
          </>
        ))}
      </Row>
      {normalParams().map((param) => (
        <>
          <Row>
            <Col
              key={`title.${param.name}`}
              flex="80px"
              style={{
                textAlign: "right",
                padding: "2px 0px 0px 0px",
                alignSelf: "center",
              }}
            >
              {isEmpty(param.column) && (
                <span style={{ fontSize: 12, color: "red" }}>*</span>
              )}
              <span style={{ fontSize: 12, color: "gray" }}>
                {param.name} :{" "}
              </span>
            </Col>
            <Col
              key={`input.${param.name}`}
              flex={"80%"}
              style={{ padding: "3px" }}
            >
              <PlaceholderFlattenInput
                md={props.md}
                disabled={props.running}
                placeholder={param}
                value={whereClause[param.name]}
                onChange={(value) => {
                  whereClause[param.name] = value;
                  setWhereClause(whereClause);
                }}
              />
            </Col>
          </Row>
        </>
      ))}
    </>
  );
}

const context = {};

function QueryingResultsView(props) {
  const [results, setResults] = useState([]);
  const [index, setIndex] = useState(1);
  const [activeKey, setActiveKey] = useState();
  const [debuggingModal, setDebuggingModal] = useState({
    visible: false,
    jobId: 0,
  });

  context.results = results;

  async function pollJob(result) {
    const fakeIncrement = 100 / result.estimatedCostSeconds;
    const status = await UIFetchService.get(
      `/api/v1/querying_guide/jobs/${result.jobId}/status`
    );
    switch (status.status) {
      case "INIT":
      case "RUNNING":
        if (result.fakePercent < 99) {
          result.fakePercent += fakeIncrement;
        }
        if (result.fakePercent > 99) {
          result.fakePercent = 99;
        }
        setResults([...context.results]);
        //setResults(results);
        break;
      case "FAIL":
        message.error(`执行失败：${status.logs}`);
        clearInterval(result.timer);
        result.running = false;
        result.message = status.logs;
        result.fakePercent = 0;
        try {
          result.debuggingInfo = await UIFetchService.get(
            `/api/v1/querying_guide/jobs/${result.jobId}/debugging_info`
          );
        } catch (e) {
          console.error(e);
        }
        setResults([...context.results]);
        //setResults(results);
        props.onJobEnd();
        window.onresize();
        break;
      case "OK":
        clearInterval(result.timer);
        if (props.tab === "dimensions") {
          if (props.projection.length === status.columns.length) {
            status.columns = props.projection.map((p) => p.name);
          }
        } else {
          if (props.original.length === status.columns.length) {
            status.columns = props.original.map((p) => p.name.toLowerCase());
          }
        }
        const columnsFmt = status.columns.map((col) => {
          let key = col;
          if (col.startsWith('"') && col.endsWith('"')) {
            key = col.substring(1, col.length - 1);
          }
          const rs = {
            type: status.columnsType[key],
            readOnly: false,
          };
          //console.log(key, col, status.columnsType, rs);
          return rs;
        });
        const rows = await UIFetchService.get(
          `/api/v1/querying_guide/jobs/${result.jobId}/all_result`
        );
        const regularRows = [];
        for (let row of rows) {
          regularRows.push(
            status.columns.map((column) => {
              column = column.toLowerCase();
              if (column.startsWith('"') && column.endsWith('"')) {
                column = column.substring(1, column.length - 1).toLowerCase();
              }
              if (status.columnsType[column] === "text") {
                return row[column.toLowerCase()];
              }
              if (column in row) {
                const val = row[column.toLowerCase()];
                if (typeof val === "string" && val?.match("^\\d+$")) {
                  return Number.parseInt(val);
                } else {
                  return val;
                }
              } else {
                return "NULL";
              }
            })
          );
        }
        result.total = status.total;
        result.columns = status.columns.map((column) => {
          if (column.startsWith('"') && column.endsWith('"')) {
            column = column.substring(1, column.length - 1);
          }
          return column.toLowerCase();
        });
        result.columnsFmt = columnsFmt;
        result.rows = regularRows;
        result.running = false;
        result.fakePercent = 100;
        setResults([...context.results]);
        props.onJobEnd();
        window.onresize();
        break;
      default:
        break;
    }
  }

  const postJob = async (id, tab) => {
    const requestBody = {
      dimensions: props.projection
        .filter((p) => p.kind === "DIMENSION")
        .map((p) => p.id),
      indicators: props.projection
        .filter((p) => p.kind === "INDICATOR")
        .map((p) => p.id),
      original: props.projection
        .filter((p) => p.kind === "ORIGINAL")
        .map((p) => p.id),
      placeholders: {},
    };
    for (const param of props.template.placeholders) {
      if (isEmpty(param.column) && isEmpty(props.whereClause[param.name])) {
        message.error(`"${param.name}" 是必选字段，必须填写才能继续查询。`);
        return;
      }
    }
    Object.keys(props.whereClause).forEach((key) => {
      let value = props.whereClause[key];
      if (value instanceof Array) {
        value = value.join(",");
      }
      requestBody.placeholders[key] = value;
    });
    const rs = await UIFetchService.post(
      `/api/v1/querying_guide/templates/${id}/post_running`,
      requestBody
    );
    if (!rs) {
      return;
    }
    const { estimatedCostSeconds, jobId } = rs;
    const result = {
      estimatedCostSeconds,
      jobId,
      index,
      version: 1,
      key: jobId.toString(),
      running: true,
      fakePercent: 0,
    };
    results.push(result);
    result.timer = setInterval(() => pollJob(result), 2000);

    props.onJobStart(jobId);
    setResults([...results]);
    setIndex(index + 1);
    setActiveKey(result.key);
  };

  const cancelJob = () => {
    const index = results.findIndex((rs) => rs.running);
    if (index >= 0) {
      if (results[index].timer !== undefined) {
        clearInterval(results[index].timer);
      }
      setResults(results.filter((_, i) => i !== index));
      props.onJobEnd();
    }
  };
  props.returningCallback([postJob, cancelJob]);

  const canExporting = () => {
    const rs = results.find((r) => r.key === activeKey);
    return rs && !rs.running;
  };

  const stillExporting = () => {
    const rs = results.find((r) => r.key === activeKey);
    return rs && !rs.running && rs.exporting;
  };

  const doExport = async () => {
    const rs = results.find((r) => r.key === activeKey);
    if (!rs) {
      return;
    }
    rs.exporting = true;
    setResults([...results]);

    message.info("开始导出数据，注意查看企业微信数据中台消息。");
    await UIFetchService.post(
      `/api/v1/querying_guide/templates/${props.template.id}/post_exporting?selectedJobId=${rs.jobId}`,
      {}
    );

    rs.exporting = false;
    setResults([...results]);
  };

  const doCopy = () => {
    const rs = results.find((r) => r.key === activeKey);
    if (!rs) {
      return;
    }
    const cols =
      rs.columns
        .map((col) => {
          const name = props.namedProjection[col.toLowerCase()];

          if (isEmpty(name)) {
            const quadName = props.namedProjection[`"${col}"`.toLowerCase()];
            if (isNotEmpty(quadName)) {
              return quadName.substring(1, quadName.length - 1);
            }
          }
          return name;
        })
        .join("\t") + "\n";
    const content = rs.rows.map((row) => row.join("\t")).join("\n");
    if (copy(cols + content, { format: "text/plain" })) {
      message.success("复制成功");
    }
  };

  return results.length === 0 ? (
    <QueryingGuidePanel height={props.tableHeight} />
  ) : (
    <>
      <Tabs
        closable={"true"}
        activeKey={activeKey}
        hideAdd
        type="editable-card"
        size="small"
        style={{ width: "100%" }}
        onChange={(activeKey) => {
          setActiveKey(activeKey);
          setTimeout(() => window.onresize(), 100);
        }}
        tabBarExtraContent={
          <>
            {canExporting() && (
              <Button
                size="small"
                icon={<BugOutlined />}
                disabled={debuggingModal.visible}
                type="link"
                onClick={() => {
                  const state = { ...debuggingModal };
                  state.visible = true;
                  state.jobId = results.find((r) => r.key === activeKey)?.jobId;
                  setDebuggingModal(state);
                }}
              >
                调试信息
              </Button>
            )}
            {canExporting() && (
              <Button
                size="small"
                disabled={stillExporting()}
                icon={<CopyOutlined />}
                type="link"
                onClick={doCopy}
              >
                复制数据
              </Button>
            )}
            {canExporting() && (
              <Button
                size="small"
                disabled={stillExporting()}
                icon={
                  stillExporting() ? <SyncOutlined spin /> : <SaveOutlined />
                }
                type="link"
                onClick={doExport}
              >
                导出数据
              </Button>
            )}
          </>
        }
        onEdit={(key, action) => {
          if (action === "remove") {
            // const spawn = results.filter(rs=>rs.key !== key);
            // setResults(spawn);
            const removeIndex = results.findIndex((rs) => rs.key === key);
            if (removeIndex < 0) {
              return;
            }
            results.splice(removeIndex, 1);
            setResults([...results]);
            //setResults(results);
            for (const rs of results) {
              if (rs.running) {
                setActiveKey(rs.key);
                return;
              }
            }
            if (results[removeIndex - 1] !== undefined) {
              setActiveKey(results[removeIndex - 1].key);
            } else if (results[removeIndex + 1] !== undefined) {
              setActiveKey(results[removeIndex + 1].key);
            }
          }
        }}
      >
        {results.map((slot) => (
          <Tabs.TabPane
            tab={
              <Space>
                <span>{`查询结果[${slot.index}]`}</span>{" "}
                {slot.running && <LoadingOutlined />}
              </Space>
            }
            key={slot.key}
            closeIcon={slot.running}
          >
            {slot.running && (
              <Row justify="center">
                <Col flex="75%" style={{ margin: "20px 0 0 0" }}>
                  <Progress
                    width={1000}
                    style={{ width: "100%" }}
                    strokeLinecap="square"
                    percent={slot.fakePercent.toFixed(2)}
                    //steps={10}
                  />
                </Col>
              </Row>
            )}
            {!slot.running && isNotEmpty(slot.message) && (
              <Row
                style={{
                  height: props.tableHeight,
                  overflowY: "auto",
                }}
              >
                <Col flex="100%">
                  <Result
                    status="error"
                    title="查询错误"
                    subTitle={slot.message}
                    extra={[
                      <Button
                        type="primary"
                        key="console"
                        onClick={() => postJob(props.template.id, props.tab)}
                      >
                        重试
                      </Button>,
                    ]}
                  >
                    {isNotEmpty(slot.debuggingInfo?.sql) && (
                      <SyntaxHighlighter
                        language="sql"
                        style={xcode}
                        showLineNumbers
                        showInlineLineNumbers
                      >
                        {slot.debuggingInfo.sql}
                      </SyntaxHighlighter>
                    )}
                  </Result>
                </Col>
              </Row>
            )}
            {!slot.running && slot.rows instanceof Array && (
              <Row>
                <Col flex="100%">
                  <QueryingRowsTable
                    namedProjection={props.namedProjection}
                    result={slot}
                    height={props.tableHeight}
                  />
                </Col>
              </Row>
            )}
          </Tabs.TabPane>
        ))}
      </Tabs>
      {debuggingModal.visible && (
        <QueryingDebuggingModal
          {...debuggingModal}
          onClose={() => {
            //debuggingModal.visible = false;
            const state = { ...debuggingModal };
            state.visible = false;
            setDebuggingModal(state);
          }}
        />
      )}
    </>
  );
}

function QueryingDebuggingModal(props) {
  const [sql, setSql] = useState();
  useEffect(() => {
    const fetch = async () => {
      const rs = await UIFetchService.get(
        `/api/v1/querying_guide/jobs/${props.jobId}/debugging_info`
      );
      setSql(rs.sql);
    };
    fetch();
  }, []);

  return (
    <Modal
      visible={props.visible}
      title="调试信息"
      maskClosable={false}
      onOk={props.onClose}
      onCancel={props.onClose}
      width={700}
    >
      <Row>
        <Col flex="100%" style={{ height: 500, overflowY: "auto" }}>
          <SyntaxHighlighter
            language="sql"
            style={xcode}
            showLineNumbers
            showInlineLineNumbers
          >
            {sql}
          </SyntaxHighlighter>
        </Col>
      </Row>
    </Modal>
  );
}

function QueryingGuidePanel(props) {
  return (
    <Row
      justify="space-around"
      align="middle"
      style={{
        fontSize: 20,
        width: "100%",
        color: "gray",
        height: props.height,
      }}
    >
      <Col style={{ alignSelf: "center" }}>
        <Row>
          <Col>
            <span>选择必选过滤条件在指定维度&指标或者明细字段后，可以开始</span>
            <Button
              style={{ margin: "0 10px 10px" }}
              icon={<PlayCircleOutlined />}
              type="primary"
              size="small"
            >
              查询
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <span>如需要终止正在进行中的查询，点击</span>
            <Button
              style={{ margin: "0 10px 10px" }}
              icon={<PauseCircleOutlined />}
              danger
              size="small"
            >
              终止
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <span>[维度/指标]、[明细字段]只能选择其一进行查询。</span>
          </Col>
        </Row>
        <Row style={{ margin: "10px 0 0 0" }}>
          <Col>
            <span>
              点击维度、指标或者字段后面的
              <PlusOutlined />
              可以将其移动到[查询字段]中。
            </span>
          </Col>
        </Row>
        <Row style={{ margin: "10px 0 0 0" }}>
          <Col>
            <span>[查询字段]中的条目可以拖动排序。</span>
          </Col>
        </Row>
        <Row style={{ margin: "10px 0 0 0" }}>
          <Col>
            <span style={{color: "red" }}>如报错[服务端错误：No message available]，可尝试删除字段，重新添加</span>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

const QueryingRowsTable = React.memo(
  (props) => {
    const [columns, setColumns] = useState(props.result.columnsFmt);
    const { result } = props;

    return (
      <HotTable
        height={props.height}
        data={result.rows}
        rowHeaders
        //colHeaders
        colHeaders={result.columns.map((col) => {
          const name = props.namedProjection[col];
          return isEmpty(name) ? col : name;
        })}
        columns={columns}
        language="zh-CN"
        manualColumnResize
        manualRowResize
        columnSorting={true}
        dropdownMenu={{
          items: {
            setFormat: {
              name: "格式",
              key: "format",
              submenu: {
                items: [
                  {
                    key: "format:1",
                    name: "原始数据",
                    callback: (key, options) => {
                      const col = options[0].start.col;
                      // result.columnsFmt[col].numericFormat = undefined;
                      columns[col].numericFormat = undefined;
                      setColumns([...columns]);
                    },
                  },
                  {
                    key: "format:2",
                    name: "整数",
                    callback: (key, options) => {
                      const col = options[0].start.col;
                      columns[col].numericFormat = {
                        pattern: "0,00",
                        culture: "zh-CN",
                      };
                      setColumns([...columns]);
                    },
                  },
                  {
                    key: "format:3",
                    name: "保留1位小数",
                    callback: (key, options) => {
                      const col = options[0].start.col;
                      columns[col].numericFormat = {
                        pattern: "0.0",
                        culture: "zh-CN",
                      };
                      setColumns([...columns]);
                    },
                  },
                  {
                    key: "format:4",
                    name: "保留2位小数",
                    callback: (key, options) => {
                      const col = options[0].start.col;
                      columns[col].numericFormat = {
                        pattern: "0.00",
                        culture: "zh-CN",
                      };
                      setColumns([...columns]);
                    },
                  },
                  {
                    key: "format:5",
                    name: "保留3位小数",
                    callback: (key, options) => {
                      const col = options[0].start.col;
                      columns[col].numericFormat = {
                        pattern: "0.000",
                        culture: "zh-CN",
                      };
                      setColumns([...columns]);
                    },
                  },
                  {
                    key: "format:6",
                    name: "保留4位小数",
                    callback: (key, options) => {
                      const col = options[0].start.col;
                      columns[col].numericFormat = {
                        pattern: "0.0000",
                        culture: "zh-CN",
                      };
                      setColumns([...columns]);
                    },
                  },
                  {
                    key: "format:7",
                    name: "百分比1位小数",
                    callback: (key, options) => {
                      const col = options[0].start.col;
                      columns[col].numericFormat = {
                        pattern: "0.0%",
                        culture: "zh-CN",
                      };
                      setColumns([...columns]);
                    },
                  },
                  {
                    key: "format:8",
                    name: "百分比2位小数",
                    callback: (key, options) => {
                      const col = options[0].start.col;
                      columns[col].numericFormat = {
                        pattern: "0.00%",
                        culture: "zh-CN",
                      };
                      setColumns([...columns]);
                    },
                  },
                ],
              },
            },
            hsep5: "---------",
            filter1: "filter_by_condition",
            filter2: "filter_operators",
            filter3: "filter_by_condition2",
            filter4: "filter_by_value",
            filter5: "filter_action_bar",
          },
        }}
        filters={true}
        manualColumnMove={true}
        manualColumnFreeze={true}
        //fixedRowsTop={1}
        licenseKey="non-commercial-and-evaluation"
      ></HotTable>
    );
  },
  (prevProps, nextProps) => {
    //console.log(prevProps, nextProps);
    return (
      prevProps.height === nextProps.height &&
      prevProps.version === nextProps.version &&
      prevProps.result.jobId === nextProps.result.jobId &&
      prevProps.result.running === nextProps.result.running
    );
  }
);

function QueryingSiderView(props) {
  return (
    <Tabs
      defaultActiveKey="dimensions"
      activeKey={props.tab}
      onChange={props.running ? undefined : props.onTabChange}
      centered
    >
      <Tabs.TabPane tab="维度/指标" key="dimensions">
        <QueryingSiderDimensionsSelector
          {...props}
          projection={props.projection}
          onProjectionChange={(projection) =>
            props.onProjectionChange(projection)
          }
          selectableProjection={props.template.projection}
          editable
          templateId={props.template.id}
        />
      </Tabs.TabPane>
      {/* <Tabs.TabPane tab="明细字段" key="original">
        <QueryingSiderIndicatorsSelector
          {...props}
          projection={props.original}
          onProjectionChange={(original) => props.onOriginalChange(original)}
          selectableProjection={props.template.projection}
        />
      </Tabs.TabPane> */}
    </Tabs>
  );
}

function QueryingSiderIndicatorsSelector(props) {
  const [fieldKey, setFieldKey] = useState("");
  const selectableProjection = props.selectableProjection
    ? props.selectableProjection
    : [];
  const [projection, setProjection] = [
    props.projection,
    props.onProjectionChange,
  ];
  const alreadyExists = (id) =>
    projection.find((p) => p.id === id) !== undefined;

  const filterField = (p) => {
    if (isEmpty(fieldKey)) {
      return true;
    }
    return p.desc.toLowerCase().indexOf(fieldKey.toLocaleLowerCase()) >= 0;
  };

  return (
    <DragDropContext
      onDragEnd={({ destination, source }) => {
        if (isEmpty(destination) || isEmpty(source)) {
          return;
        }
        if (destination.droppableId === "projectionDest") {
          if (source.droppableId === "projectionDest") {
            const [remove] = projection.splice(source.index, 1);
            projection.splice(destination.index, 0, remove);
          } else if (source.droppableId === "originalSrc") {
            const proj = selectableProjection
              .filter((p) => p.kind === "ORIGINAL" && !alreadyExists(p.id))
              .filter(filterField)[source.index];
            if (projection.find((p) => p.id === proj.id)) {
              message.error("字段重复。");
              return;
            }
            projection.splice(destination.index, 0, proj);
          }
          setProjection([...projection]);
        }
      }}
    >
      <Row>
        <Col flex="50%" style={{ padding: "10px" }}>
          <Row>
            <span style={{ fontSize: 12, color: "gray" }}>字段</span>
          </Row>
          <Row style={{ margin: "0 0 7px 0" }}>
            <Col flex="100%">
              <Input.Search
                size="small"
                value={fieldKey}
                allowClear
                placeholder="输入关键字进行搜索"
                onChange={({ target: { value } }) => setFieldKey(value)}
              />
            </Col>
          </Row>
          <Row>
            <Col flex="100%" style={{ overflowY: "auto", maxHeight: "400px" }}>
              <QueryingProjectionSelector
                placeholder={
                  <div
                    style={{
                      border: "2px dotted gray",
                      fontSize: 12,
                      color: "gray",
                      padding: "4px 0px",
                    }}
                  >
                    无可用字段
                  </div>
                }
                droppableId="originalSrc"
                items={selectableProjection
                  .filter((p) => p.kind === "ORIGINAL" && !alreadyExists(p.id))
                  .filter(filterField)}
                options={{
                  onAdd: (proj) => {
                    if (projection.find((p) => p.id === proj.id)) {
                      message.error("字段重复。");
                      return;
                    }
                    setProjection([...projection, proj]);
                  },
                  // onEdit: proj => {
                  //     console.log(proj);
                  // },
                  // onRemove: proj => {
                  //     console.log(proj);
                  // }
                }}
              />
            </Col>
          </Row>
          <Divider style={{ margin: "20px 0" }} />
        </Col>

        <Col flex="50%" style={{ padding: "10px 6px 10px 6px" }}>
          <Row>
            <span style={{ fontSize: 12, color: "gray" }}>查询字段</span>
          </Row>
          <Row>
            <Col
              flex="100%"
              style={{
                border: "1px dotted gray",
                overflowY: "auto",
                maxHeight: "400px",
              }}
            >
              <QueryingProjectionSelector
                placeholder="拖动字段到此处"
                droppableId="projectionDest"
                selection={true}
                items={projection}
                options={{
                  onDelete: (_, index) => {
                    projection.splice(index, 1);
                    setProjection([...projection]);
                  },
                }}
              />
            </Col>
          </Row>
          <Divider style={{ margin: "20px 0" }} />
          <Row>
            <Col flex="100%">
              {props.running ? (
                <Button
                  type="primary"
                  danger
                  style={{ width: "100%" }}
                  onClick={() => props.onCancel()}
                >
                  终止
                </Button>
              ) : (
                <Button
                  type="primary"
                  style={{ width: "100%" }}
                  disabled={projection.length === 0}
                  onClick={() => props.onQuery(projection)}
                >
                  查询
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </DragDropContext>
  );
}

function QueryingSiderDimensionsSelector(props) {
  const [dimKey, setDimKey] = useState("");
  const [idxKey, setIdxKey] = useState("");
  const [fieldKey, setFieldKey] = useState("");
  const [selectableProjection, setSelectableProjection] = useState([]);

  useEffect(() => {
    if (Array.isArray(props.selectableProjection)) {
      const arr = props.selectableProjection;
      arr.sort((a, b) => a.sort - b.sort);
      setSelectableProjection(arr);
    } else {
      setSelectableProjection([]);
    }
  }, [props.selectableProjection]);

  const [projection, setProjection] = [
    props.projection,
    props.onProjectionChange,
  ];
  const alreadyExists = (id) =>
    projection.find((p) => p.id === id) !== undefined;

  const filterDims = (p) => {
    if (isEmpty(dimKey)) {
      return true;
    }
    return p.desc.toLowerCase().indexOf(dimKey.toLowerCase()) >= 0;
  };

  const filterIdxs = (p) => {
    if (isEmpty(idxKey)) {
      return true;
    }
    return p.desc.toLowerCase().indexOf(idxKey.toLowerCase()) >= 0;
  };

  const filterField = (p) => {
    if (isEmpty(fieldKey)) {
      return true;
    }
    return p.desc.toLowerCase().indexOf(fieldKey.toLocaleLowerCase()) >= 0;
  };

  function renderContextMenu(proj) {
    return (
      <Menu
        theme="dark"
        style={{ fontSize: 12 }}
        onClick={({ key }) => {
          switch (key) {
            case "edit":
              props.willEditField(proj.name);
              break;
            case "delete":
              props.onDeleteField(proj.name);
              break;
            default:
              break;
          }
        }}
      >
        <Menu.Item key="edit">
          <span style={{ fontSize: 12 }}>编辑</span>
        </Menu.Item>
        <Menu.Item key="delete">
          <span style={{ fontSize: 12 }}>删除</span>
        </Menu.Item>
      </Menu>
    );
  }

  const conflictError = () => {
    return message.error("[维度/指标]、[明细字段]只能选择其一进行查询！");
  };

  const saveSort = (id, sorted) => {
    UIFetchService.put(
      `/api/v1/querying_guide/templates/${id}/projections/reorder`,
      sorted
    );
  };

  return (
    <DragDropContext
      onDragEnd={({ destination, source }) => {
        if (isEmpty(destination) || isEmpty(source)) {
          return;
        }
        // 换位
        if (
          destination.droppableId === source.droppableId &&
          destination.index !== source.index &&
          destination.droppableId !== "projectionDest"
        ) {
          let sourceIndex = 0;
          let targetIndex = 0;
          let dims = [];
          // 计算换位的原先位置
          if (destination.droppableId === "dimensionsSrc") {
            dims = selectableProjection
              .filter((p) => p.kind === "DIMENSION" && !alreadyExists(p.id))
              .filter(filterDims);
          } else if (destination.droppableId === "indicatorsSrc") {
            dims = selectableProjection
              .filter((p) => p.kind === "INDICATOR" && !alreadyExists(p.id))
              .filter(filterIdxs);
          } else if (destination.droppableId === "originalSrc") {
            dims = selectableProjection
              .filter((p) => p.kind === "ORIGINAL" && !alreadyExists(p.id))
              .filter(filterField);
          }
          const sourceItem = dims[source.index];
          const targetItem = dims[destination.index];
          sourceIndex = selectableProjection.indexOf(sourceItem);
          targetIndex = selectableProjection.indexOf(targetItem);
          const [remove] = selectableProjection.splice(sourceIndex, 1);
          selectableProjection.splice(targetIndex, 0, remove);
          setSelectableProjection([...selectableProjection]);
          // 保存顺序
          saveSort(
            props.templateId,
            selectableProjection.map((item, index) => ({
              ...item,
              sort: index,
            }))
          );
          return;
        }
        if (destination.droppableId === "projectionDest") {
          // 内部换位
          if (source.droppableId === "projectionDest") {
            const [remove] = projection.splice(source.index, 1);
            projection.splice(destination.index, 0, remove);
          } else {
            // 添加的时候需要判断【维度/指标】和【明细字段】的冲突
            if (source.droppableId === "dimensionsSrc") {
              if (projection.some((pro) => pro.kind === "ORIGINAL")) {
                conflictError();
                return;
              }
              const proj = selectableProjection
                .filter((p) => p.kind === "DIMENSION" && !alreadyExists(p.id))
                .filter(filterDims)[source.index];
              if (projection.find((p) => p.id === proj.id)) {
                message.error("维度重复。");
                return;
              }
              projection.splice(destination.index, 0, proj);
            } else if (source.droppableId === "indicatorsSrc") {
              if (projection.some((pro) => pro.kind === "ORIGINAL")) {
                conflictError();
                return;
              }
              const proj = selectableProjection
                .filter((p) => p.kind === "INDICATOR" && !alreadyExists(p.id))
                .filter(filterIdxs)[source.index];
              if (projection.find((p) => p.id === proj.id)) {
                message.error("指标重复。");
                return;
              }
              projection.splice(destination.index, 0, proj);
            } else if (source.droppableId === "originalSrc") {
              if (
                projection.some((pro) =>
                  ["DIMENSION", "INDICATOR"].includes(pro.kind)
                )
              ) {
                conflictError();
                return;
              }
              const proj = selectableProjection
                .filter((p) => p.kind === "ORIGINAL" && !alreadyExists(p.id))
                .filter(filterField)[source.index];
              if (projection.find((p) => p.id === proj.id)) {
                message.error("字段重复。");
                return;
              }
              projection.splice(destination.index, 0, proj);
            }
          }
          setProjection([...projection]);
        }
      }}
    >
      <Row>
        <Col flex="50%" style={{ padding: "10px" }}>
          <Row>
            <Col>
              <span style={{ fontSize: 12, color: "gray" }}>维度</span>
            </Col>
            <Col flex="auto"></Col>
            {props.template.editable && (
              <Col>
                <Tooltip
                  color="#f50"
                  placement="right"
                  trigger={["hover"]}
                  title="点此新建维度"
                  visible={props.hint}
                >
                  <Button
                    icon={<PlusOutlined />}
                    type="link"
                    size="small"
                    style={{ width: 16, height: 16 }}
                    onClick={() => props.willAddField("DIMENSION")}
                  />
                </Tooltip>
              </Col>
            )}
          </Row>
          <Row style={{ margin: "0 0 7px 0" }}>
            <Col flex="100%">
              <Input.Search
                size="small"
                value={dimKey}
                allowClear
                placeholder="输入关键字进行搜索"
                onChange={({ target: { value } }) => setDimKey(value)}
              />
            </Col>
          </Row>
          <Row>
            <Col
              flex="100%"
              style={{ maxHeight: "250px", overflow: "auto" }}
              className="hideScroll"
            >
              <QueryingProjectionSelector
                placeholder={
                  <div
                    style={{
                      border: "1px dotted gray",
                      fontSize: 12,
                      color: "gray",
                      padding: "4px 0px",
                    }}
                  >
                    无可用维度
                  </div>
                }
                droppableId="dimensionsSrc"
                items={selectableProjection
                  .filter((p) => p.kind === "DIMENSION" && !alreadyExists(p.id))
                  .filter(filterDims)}
                options={{
                  onAdd: (proj) => {
                    if (projection.some((pro) => pro.kind === "ORIGINAL")) {
                      conflictError();
                      return;
                    }
                    if (projection.find((p) => p.id === proj.id)) {
                      message.error("维度重复。");
                      return;
                    }
                    setProjection([...projection, proj]);
                  },
                  renderContextMenu: props.template.editable
                    ? renderContextMenu
                    : undefined,
                }}
              />
            </Col>
          </Row>
          <Divider style={{ margin: "20px 0" }} />
          <Row>
            <Col>
              <span style={{ fontSize: 12, color: "gray" }}>指标</span>
            </Col>
            <Col flex="auto"></Col>
            {props.template.editable && (
              <Col>
                <Tooltip
                  color="#f50"
                  placement="right"
                  trigger={["hover"]}
                  title="点此新建指标"
                  visible={props.hint}
                >
                  <Button
                    icon={<PlusOutlined />}
                    type="link"
                    size="small"
                    style={{ width: 16, height: 16 }}
                    onClick={() => props.willAddField("INDICATOR")}
                  />
                </Tooltip>
              </Col>
            )}
          </Row>
          <Row style={{ margin: "0 0 7px 0" }}>
            <Col flex="100%">
              <Input.Search
                size="small"
                value={idxKey}
                allowClear
                placeholder="输入关键字进行搜索"
                onChange={({ target: { value } }) => setIdxKey(value)}
              />
            </Col>
          </Row>
          <Row>
            <Col
              flex="100%"
              style={{ maxHeight: "250px", overflow: "auto" }}
              className="hideScroll"
            >
              <QueryingProjectionSelector
                placeholder={
                  <div
                    style={{
                      border: "1px dotted gray",
                      fontSize: 12,
                      color: "gray",
                      padding: "4px 0px",
                    }}
                  >
                    无可用指标
                  </div>
                }
                droppableId="indicatorsSrc"
                items={selectableProjection
                  .filter((p) => p.kind === "INDICATOR" && !alreadyExists(p.id))
                  .filter(filterIdxs)}
                options={{
                  onAdd: (proj) => {
                    if (projection.some((pro) => pro.kind === "ORIGINAL")) {
                      conflictError();
                      return;
                    }
                    if (projection.find((p) => p.id === proj.id)) {
                      message.error("指标重复。");
                      return;
                    }
                    setProjection([...projection, proj]);
                  },
                  renderContextMenu: props.template.editable
                    ? renderContextMenu
                    : undefined,
                  alreadyExists: (id) =>
                    projection.find((p) => p.id === id) !== undefined,
                }}
              />
            </Col>
          </Row>
          <Divider style={{ margin: "20px 0" }} />
          <Row>
            <span style={{ fontSize: 12, color: "gray" }}>字段</span>
          </Row>
          <Row style={{ margin: "0 0 7px 0" }}>
            <Col flex="100%">
              <Input.Search
                size="small"
                value={fieldKey}
                allowClear
                placeholder="输入关键字进行搜索"
                onChange={({ target: { value } }) => setFieldKey(value)}
              />
            </Col>
          </Row>
          <Row>
            <Col
              flex="100%"
              style={{ overflow: "auto", maxHeight: "250px" }}
              className="hideScroll"
            >
              <QueryingProjectionSelector
                placeholder={
                  <div
                    style={{
                      border: "2px dotted gray",
                      fontSize: 12,
                      color: "gray",
                      padding: "4px 0px",
                    }}
                  >
                    无可用字段
                  </div>
                }
                droppableId="originalSrc"
                items={selectableProjection
                  .filter((p) => p.kind === "ORIGINAL" && !alreadyExists(p.id))
                  .filter(filterField)}
                options={{
                  onAdd: (proj) => {
                    if (
                      projection.some((pro) =>
                        ["DIMENSION", "INDICATOR"].includes(pro.kind)
                      )
                    ) {
                      conflictError();
                      return;
                    }
                    if (projection.find((p) => p.id === proj.id)) {
                      message.error("字段重复。");
                      return;
                    }
                    setProjection([...projection, proj]);
                  },
                  // onEdit: proj => {
                  //     console.log(proj);
                  // },
                  // onRemove: proj => {
                  //     console.log(proj);
                  // }
                }}
              />
            </Col>
          </Row>
        </Col>
        <Col
          flex="50%"
          style={{ padding: "10px 6px 10px 6px", position: "relative" }}
        >
          <Row>
            <span style={{ fontSize: 12, color: "gray" }}>查询字段</span>
          </Row>
          <Row>
            <Col
              flex="100%"
              style={{
                border: "1px dotted gray",
                maxHeight: "500px",
                overflow: "auto",
              }}
              className="hideScroll"
            >
              <QueryingProjectionSelector
                placeholder="添加指标/维度到此处"
                droppableId="projectionDest"
                selection={true}
                items={projection}
                options={{
                  onDelete: (proj, index) => {
                    projection.splice(index, 1);
                    setProjection([...projection]);
                  },
                }}
              />
            </Col>
          </Row>
          <Divider style={{ margin: "20px 0" }} />
          <Row>
            <Col flex="100%">
              {props.running ? (
                <Button
                  type="primary"
                  danger
                  style={{ width: "100%" }}
                  onClick={() => props.onCancel()}
                >
                  终止
                </Button>
              ) : (
                <Button
                  type="primary"
                  disabled={projection.length === 0}
                  style={{ width: "100%" }}
                  onClick={() => props.onQuery(projection)}
                >
                  查询
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </DragDropContext>
  );
}

function QueryingProjectionSelector(props) {
  const options = props.options ? props.options : {};

  return (
    <Droppable droppableId={props.droppableId}>
      {(provided) => (
        <>
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {props.items.length === 0 && (
              <Draggable
                isDragDisabled
                draggableId={props.droppableId + "-fake"}
                key={props.droppableId + "-fake"}
                index={-1}
              >
                {(p1) => (
                  <div
                    ref={p1.innerRef}
                    {...p1.draggableProps}
                    {...p1.dragHandleProps}
                  >
                    <div style={{ width: "100%", textAlign: "center" }}>
                      {typeof props.placeholder === "string" ? (
                        <span style={{ fontSize: 12, color: "gray" }}>
                          {props.placeholder}
                        </span>
                      ) : (
                        props.placeholder
                      )}
                    </div>
                  </div>
                )}
              </Draggable>
            )}
            {props.items.map((proj, index) =>
              proj === undefined ? (
                <></>
              ) : (
                <Draggable
                  draggableId={`${props.droppableId}-${proj.id}`}
                  key={`${props.droppableId}-${proj.id}`}
                  index={index}
                >
                  {(provided) => {
                    // if (props.droppableId === 'projectionDest') {
                    //     console.log(proj, index);
                    // }
                    let color = "#52c41a";
                    let fontColor = "#ffffff";
                    switch (proj.kind) {
                      case "DIMENSION":
                        //color = props.selection ? '#1890ff' : '#2f54eb';
                        color = props.selection ? "#2f54eb" : "#ffffff";
                        fontColor = props.selection ? "#ffffff" : "#2f54eb";
                        break;
                      case "INDICATOR":
                        //color = props.selection ? '#13c2c2' : '#52c41a';
                        color = props.selection ? "#52c41a" : "#ffffff";
                        fontColor = props.selection ? "#ffffff" : "#52c41a";
                        break;
                      case "ORIGINAL":
                        //color = props.selection ? '#13c2c2' : '#52c41a';
                        color = props.selection ? "#52c41a" : "#ffffff";
                        fontColor = props.selection ? "#ffffff" : "#52c41a";
                        break;
                      default:
                        break;
                    }
                    return (
                      <div
                        key={proj.id}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <Row
                          style={{
                            backgroundColor: color,
                            padding: "2px 12px 2px 12px",
                            borderRadius: "4px",
                            border: `1px solid ${
                              props.selection ? "rgb(221, 234, 255)" : fontColor
                            }`,
                            alignSelf: "center",
                            margin: !props.selection && "0 0 3px 0",
                          }}
                        >
                          <Col
                            style={{
                              overflow: "hidden",
                              //textOverflow: 'ellipsis',
                              //whiteSpace: 'nowrap',
                              maxWidth: 110,
                            }}
                          >
                            {proj.desc && proj.desc.length > 15 ? (
                              <Tooltip title={proj.desc}>
                                <span
                                  style={{ fontSize: 12, color: fontColor }}
                                >
                                  {proj.desc.substring(0, 15)}...
                                </span>
                              </Tooltip>
                            ) : (
                              <span style={{ fontSize: 12, color: fontColor }}>
                                {proj.desc || ""}
                              </span>
                            )}
                          </Col>
                          {(options.onAdd ||
                            options.onDelete ||
                            options.renderContextMenu) && (
                            <Col flex="auto"></Col>
                          )}
                          {options.renderContextMenu && (
                            <Col>
                              <Dropdown
                                overlay={options.renderContextMenu(proj)}
                              >
                                <Button
                                  icon={<CaretDownOutlined />}
                                  size="small"
                                  type="link"
                                  style={{ color: fontColor }}
                                />
                              </Dropdown>
                            </Col>
                          )}
                          {options.onAdd && (
                            <Col>
                              <Button
                                size="small"
                                type="link"
                                style={{ color: fontColor }}
                                icon={<PlusOutlined />}
                                onClick={() => options.onAdd(proj)}
                              ></Button>
                            </Col>
                          )}
                          {options.onDelete && (
                            <Col>
                              <Button
                                size="small"
                                type="link"
                                style={{ color: fontColor }}
                                icon={<DeleteOutlined />}
                                onClick={() => options.onDelete(proj, index)}
                              ></Button>
                            </Col>
                          )}
                        </Row>
                      </div>
                    );
                  }}
                </Draggable>
              )
            )}
          </div>
          {provided.placeholder}
        </>
      )}
    </Droppable>
  );
}

class IndicatorEditorModal extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  // (indicator, index, addOrUpdate)
  render() {
    return (
      <Modal
        title="指标"
        visible={this.props.visible}
        onOk={this.commit.bind(this)}
        onCancel={this.props.onCancel}
        maskClosable={false}
      >
        <Row>
          <Col flex="80px" style={{ alignSelf: "center" }}>
            <span style={{ color: "red" }}>*</span>
            <span>显示名：</span>
          </Col>
          <Col flex="auto">
            <Input
              value={this.state.desc}
              onChange={({ target: { value } }) =>
                this.setState({ desc: value, descError: undefined })
              }
              placeholder="请输入显示名，可以为中文"
            />
          </Col>
        </Row>
        {this.renderError("desc")}
        <div style={{ height: 10 }} />
        <Row>
          <Col flex="80px" style={{ alignSelf: "center" }}>
            说明：
          </Col>
          <Col flex="auto">
            <Input
              value={this.state.comments}
              onChange={({ target: { value } }) =>
                this.setState({ comments: value })
              }
            />
          </Col>
        </Row>
        <div style={{ height: 10 }} />
        <Row>
          <Col
            flex="80px"
            style={{ alignSelf: "center", verticalAlign: "start" }}
          >
            <span style={{ color: "red" }}>*</span>
            <span>表达式：</span>
          </Col>
          <Col flex="auto">
            <div
              id="indicator-expr-editor"
              style={{ height: 70, border: "1px solid #d9d9d9" }}
            />
          </Col>
        </Row>
        {this.renderError("expr")}
        <div style={{ height: 10 }} />
        <FieldAndFunctionsGuide
          innerHeight={300}
          fields={this.props.fields}
          funs={odpsFuns.sort()}
          injectFun={(fun) => this.insertToCurrentEditor(`${fun}()`)}
          injectField={(field) => this.insertToCurrentEditor(`${field.name}`)}
        />
      </Modal>
    );
  }

  componentDidMount() {
    if (this.props.addOrUpdate) {
      let i = 0;
      while (i++ < 10000) {
        if (!this.props.alreadyExistName(`col${i}`)) {
          break;
        }
      }
      this.setState({
        kind: "INDICATOR",
        name: `col${i}`,
      });
      //console.log(i);
    } else {
      this.setState({ ...this.props.incomingIndicator });
    }

    const domNode = document.getElementById("indicator-expr-editor");
    const instance = monaco.editor.create(domNode, {
      value: this.props.addOrUpdate ? "" : this.props.incomingIndicator.expr,
      theme: "vs-light",
      fontSize: 10,
      language: "sql",
      automaticLayout: true,
      lineNumbers: "off",
      minimap: { enabled: false },
      lineDecorationsWidth: 0,
      folding: false,
    });
    this.editor = instance;
  }

  componentWillUnmount() {
    this.editor.dispose();
  }

  renderError(key) {
    if (isNotEmpty(this.state[key + "Error"])) {
      return (
        <Row>
          <Col flex="80px" />
          <Col>
            <span style={{ color: "red" }}>{this.state[key + "Error"]}</span>
          </Col>
        </Row>
      );
    }
    return <></>;
  }

  insertToCurrentEditor(text) {
    const instance = this.editor;
    if (instance === undefined) {
      return;
    }
    const selection = instance.getSelection();
    const id = { major: 1, minor: 1 };
    const op = {
      identifier: id,
      range: selection,
      text,
      forceMoveMarkers: true,
    };
    instance.executeEdits("insert", [op]);
    instance.focus();
  }

  commit() {
    const data = { ...this.state };
    data.expr = this.editor.getValue();
    if (this.check(data) > 0) {
      message.error("填写不正确，无法提交。");
      return;
    }

    Object.keys(data)
      .filter((key) => key.endsWith("Error"))
      .forEach((key) => delete data[key]);

    this.props.onOk(data, this.props.incomingIndex, this.props.addOrUpdate);
  }

  check(data) {
    console.log(this.state, data);
    const keys = {
      name: "字段名",
      desc: "显示名",
      expr: "表达式",
    };
    let err = 0;
    const params = {};
    for (let key of Object.keys(keys)) {
      if (isEmpty(data[key])) {
        params[key + "Error"] = `${keys[key]}不能为空`;
        err++;
      } else {
        params[key + "Error"] = undefined;
      }
    }
    if (isEmpty(data.name)) {
      params.nameError = "字段名不能为空";
      err++;
    } else if (data.name.match("^[\\w_][\\w\\d_]+$") === null) {
      params.nameError = "字段名不正确('^[\\w_][\\w\\d_]+$')";
      err++;
    } else {
      params.nameError = undefined;
    }

    console.log(params);
    this.setState(params);
    return err;
  }
}

class DimensionEditorModal extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <Modal
        title="维度"
        visible={this.props.visible}
        onOk={this.commit.bind(this)}
        onCancel={this.props.onCancel}
        maskClosable={false}
      >
        <Row>
          <Col flex="80px" style={{ alignSelf: "center" }}>
            <span style={{ color: "red" }}>*</span>
            <span>显示名：</span>
          </Col>
          <Col flex="auto">
            <Input
              value={this.state.desc}
              onChange={({ target: { value } }) =>
                this.setState({ desc: value, descError: undefined })
              }
              placeholder="请输入显示名，可以为中文"
            />
          </Col>
        </Row>
        {this.renderError("desc")}
        <div style={{ height: 10 }} />
        <Row>
          <Col>
            <Checkbox
              onChange={({ target: { checked } }) => {
                if (checked) {
                  this.setState({
                    expr: undefined,
                    exprError: undefined,
                    field: true,
                  });
                  this.editor.setValue("");
                  this.editor.updateOptions({ readOnly: true });
                } else {
                  this.setState({ field: false });
                }
              }}
              checked={this.state.field}
            >
              已有字段
            </Checkbox>
          </Col>
          <Col>
            <span style={{ fontSize: 12, color: "gray" }}>
              直接选择已有的字段作为维度
            </span>
          </Col>
        </Row>
        <Row>
          <Col flex="80px" />
          <Col flex="auto">
            <Radio.Group
              onChange={({ target: { value } }) => {
                this.setState({ expr: value, exprError: undefined });
                this.editor.setValue(value);
              }}
              value={this.state.expr}
              disabled={!this.state.field}
            >
              {this.props.fields.map((field) => (
                <Radio value={field.name}>{field.name}</Radio>
              ))}
            </Radio.Group>
          </Col>
        </Row>
        <div style={{ height: 10 }} />
        <Row>
          <Col>
            <Checkbox
              onChange={({ target: { checked } }) => {
                if (checked) {
                  this.setState({
                    expr: undefined,
                    exprError: undefined,
                    field: false,
                  });
                  this.editor.setValue("");
                  this.editor.updateOptions({ readOnly: false });
                } else {
                  this.setState({ field: true });
                }
              }}
              checked={!this.state.field}
            >
              表达式
            </Checkbox>
          </Col>
          <Col>
            <span style={{ fontSize: 12, color: "gray" }}>
              可以输入有效的SQL表达式为维度
            </span>
          </Col>
        </Row>
        <Row>
          <Col flex="80px" />
          <Col flex="auto">
            <div
              id="dimension-expr-editor"
              style={{ height: 70, border: "1px solid #d9d9d9" }}
            />
          </Col>
        </Row>
        {this.renderError("expr")}
        <div style={{ height: 10 }} />
        <FieldAndFunctionsGuide
          innerHeight={200}
          fields={this.props.fields}
          funs={odpsFuns.sort()}
          injectFun={(fun) => this.insertToCurrentEditor(`${fun}()`)}
          injectField={(field) => this.insertToCurrentEditor(`${field.name}`)}
        />
        <div style={{ height: 10 }} />
        <Row>
          <Col flex="80px" style={{ alignSelf: "center" }}>
            说明：
          </Col>
          <Col flex="auto">
            <Input
              value={this.state.comments}
              onChange={({ target: { value } }) =>
                this.setState({ comments: value })
              }
            />
          </Col>
        </Row>
      </Modal>
    );
  }

  componentDidMount() {
    if (this.props.addOrUpdate) {
      let i = 0;
      while (i++ < 10000) {
        if (!this.props.alreadyExistName(`col${i}`)) {
          break;
        }
      }
      this.setState({
        kind: "DIMENSION",
        name: `col${i}`,
      });
    } else {
      this.setState({ ...this.props.incomingDimension });
    }

    const domNode = document.getElementById("dimension-expr-editor");
    const instance = monaco.editor.create(domNode, {
      value: this.props.addOrUpdate ? "" : this.props.incomingDimension.expr,
      theme: "vs-light",
      fontSize: 12,
      language: "sql",
      automaticLayout: true,
      lineNumbers: "off",
      minimap: { enabled: false },
      lineDecorationsWidth: 0,
      folding: false,
    });
    this.editor = instance;
  }

  componentWillUnmount() {
    this.editor.dispose();
  }

  renderError(key) {
    if (isNotEmpty(this.state[key + "Error"])) {
      return (
        <Row>
          <Col flex="80px" />
          <Col>
            <span style={{ color: "red" }}>{this.state[key + "Error"]}</span>
          </Col>
        </Row>
      );
    }
    return <></>;
  }

  commit() {
    if (this.check() > 0) {
      message.error("填写不正确，无法提交。");
      return;
    }

    const data = { ...this.state };
    Object.keys(data)
      .filter((key) => key.endsWith("Error"))
      .forEach((key) => delete data[key]);
    data.expr = this.editor.getValue();
    this.props.onOk(data, this.props.incomingIndex, this.props.addOrUpdate);
  }

  check() {
    const keys = {
      name: "字段名",
      desc: "显示名",
      //expr: '表达式'
    };
    let err = 0;
    const params = {};
    for (let key of Object.keys(keys)) {
      if (isEmpty(this.state[key])) {
        params[key + "Error"] = `${keys[key]}不能为空`;
        err++;
      } else {
        params[key + "Error"] = undefined;
      }
    }
    if (isEmpty(this.editor.getValue())) {
      params.exprError = `表达式不能为空`;
    } else {
      params.exprError = undefined;
    }
    if (isEmpty(this.state.name)) {
      params.nameError = "字段名不能为空";
      err++;
    } else if (this.state.name.match("^[\\w_][\\w\\d_]+$") === null) {
      params.nameError = "字段名不正确('^[\\w_][\\w\\d_]+$')";
      err++;
    } else {
      params.nameError = undefined;
    }

    //console.log(params);
    this.setState(params);
    return err;
  }

  insertToCurrentEditor(text) {
    const instance = this.editor;
    if (instance === undefined) {
      return;
    }
    const selection = instance.getSelection();
    const id = { major: 1, minor: 1 };
    const op = {
      identifier: id,
      range: selection,
      text,
      forceMoveMarkers: true,
    };
    instance.executeEdits("insert", [op]);
    instance.focus();
  }
}

class FieldAndFunctionsGuide extends React.Component {
  constructor() {
    super();
    this.state = {
      fieldKey: "",
      funKey: "",
    };
  }

  render() {
    return (
      <Row>
        <Col flex="50%" style={{ padding: "0 5px 0 0" }}>
          <Row>
            <Col>
              <span style={{ fontSize: 12, color: "gray" }}>点击引用字段</span>
            </Col>
          </Row>
          <Row>
            <Col flex="100%">
              <Input.Search
                value={this.state.fieldKey}
                onChange={({ target: { value } }) =>
                  this.setState({ fieldKey: value })
                }
                size="small"
              />
            </Col>
          </Row>
          <div style={{ height: 4 }} />
          <Row>
            <Col flex="100%">
              <List
                style={{
                  width: "auto",
                  overflowX: "auto",
                  height: this.props.innerHeight,
                  overflowY: "auto",
                  wordBreak: "keep-all",
                  whiteSpace: "nowrap",
                }}
              >
                {this.props.fields
                  .filter((field) => {
                    if (isEmpty(this.state.fieldKey)) {
                      return true;
                    }
                    return field.desc.indexOf(this.state.fieldKey) > -1;
                  })
                  .map((field) => (
                    <List.Item
                      key={field.name}
                      style={{ padding: "4px", cursor: "pointer" }}
                      onClick={() => this.props.injectField(field)}
                    >
                      <code style={{ fontSize: 12 }}>{field.desc}</code>
                    </List.Item>
                  ))}
              </List>
            </Col>
          </Row>
        </Col>
        <Col flex="50%" style={{ padding: "0 0 0 5px" }}>
          <Row>
            <Col>
              <span style={{ fontSize: 12, color: "gray" }}>点击引用函数</span>
            </Col>
          </Row>
          <Row>
            <Col flex="100%">
              <Input.Search
                value={this.state.funKey}
                onChange={({ target: { value } }) =>
                  this.setState({ funKey: value })
                }
                size="small"
              />
            </Col>
          </Row>
          <div style={{ height: 4 }} />
          <Row>
            <Col flex="100%">
              <List
                header="函数"
                style={{
                  width: "auto",
                  overflowX: "auto",
                  height: this.props.innerHeight,
                  overflowY: "auto",
                  wordBreak: "keep-all",
                  whiteSpace: "nowrap",
                }}
              >
                {this.props.funs
                  .filter((fun) => {
                    if (isEmpty(this.state.funKey)) {
                      return true;
                    }
                    return fun.indexOf(this.state.funKey.toUpperCase()) > -1;
                  })
                  .map((fun) => (
                    <List.Item
                      key={fun}
                      style={{ padding: "4px", cursor: "pointer" }}
                      onClick={() => this.props.injectFun(fun)}
                    >
                      <code style={{ fontSize: 12, color: "#1890ff" }}>
                        {fun}
                      </code>
                    </List.Item>
                  ))}
              </List>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default TemplateQueryingViewV2;
